import { useEffect, useRef, useState } from 'react';

export function useMinShow(active: boolean, minMs = 600): boolean {
  const [show, setShow] = useState(active);
  const startedAt = useRef<number | null>(active ? Date.now() : null);

  useEffect(() => {
    if (active) {
      if (startedAt.current === null) startedAt.current = Date.now();
      setShow(true);
      return;
    }

    if (startedAt.current === null) {
      setShow(false);
      return;
    }

    const elapsed = Date.now() - startedAt.current;
    const remaining = Math.max(0, minMs - elapsed);

    if (remaining === 0) {
      setShow(false);
      startedAt.current = null;
      return;
    }

    const t = setTimeout(() => {
      setShow(false);
      startedAt.current = null;
    }, remaining);
    return () => clearTimeout(t);
  }, [active, minMs]);

  return show;
}
